/**
 * @module Wigdet
 */

import { Component, Input } from '@angular/core';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-elements-chart-gauge-pointer-display',
  templateUrl: './theme-option-elements-chart-gauge-pointer-display.component.html',
  styleUrls: ['./theme-option-elements-chart-gauge-pointer-display.component.css']
})
export class ThemeOptionElementsChartGaugePointerDisplayComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'elements_chart_gauge_pointer_display';
  showDetails: boolean;

  constructor() {}

  receiveValue(value: boolean) {
    this.themeOptions.setOption(this.optionType, value);
  }

}